import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-event-get-event-and-moi-data-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe]
})
export class EventGetEventAndMoiDataManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Get Event and Moi Data API",
            httpMethod: "GET",
            path: "/eventdata/eventmois",

            parameters: [
                {
                    name: "includeDeleted",
                    in: "query",
                    paramType: "boolean",
                    required: false,
                    example: "true | false",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: {
                        events: [
                            {
                                identifier: "string",
                                "internal Identifier": "string",
                                "event name": "string",
                                "incident type(s)": "string",
                                classification: "string",
                                organization: "string",
                                "date occurred": "datetime",
                                "date detected": "datetime",
                                "date registered": "datetime",
                                "date closed": "datetime",
                                "event category": "string",
                                reporter: "string",
                                responsible: "string",
                                assessor: "string",
                                informed: "string",
                                "event description": "string",
                                "primary cause": "string",
                                "secondary cause": "string",
                                "cause description": "string",
                                "effect(s)": "string",
                                "effect description": "string",
                                "impact description": "string",
                                "reputation impact": "string",
                                "reputation impact description": "string",
                                "caused by organization": "string",
                                "affected organization": "string",
                                "gross costs": "integer",
                                recovery: "integer",
                                "net costs": "integer",
                                currency: "string",
                                comments: "string",
                                "risk opinion": "string",
                                "business dimension path(s)": "string",
                                "business dimension(s)": "string",
                                "business line": "string",
                                "completed by": "string",
                                status: "string",
                                "organization path": "string",
                            },
                        ],
                        "event MoIs": [
                            {
                                "event Identifier": "string",
                                "event name": "string",
                                "moI Identifier": "string",
                                "moI Name": "string",
                                subject: "string",
                                status: "string",
                                priority: "string",
                                feasibility: "string",
                                progress: "integer",
                                "organization Responsible": "string",
                                responsible: "string",
                                delegate: "string",
                                "organization Reviewer": "string",
                                reviewer: "string",
                                "finding Description": "string",
                                "start Date": "datetime",
                                "date Created": "datetime",
                                "due Date": "datetime",
                                "initial Due Date": "datetime",
                                "implementation Score": "string",
                                recommendation: "string",
                                "management Response": "string",
                                "last Comment": "string",
                                "comment Date": "datetime",
                                "business Dimension Paths": "string",
                                "business Dimensions": "string",
                            },
                        ],
                    },
                },
            ],
        };
    }
}
